<template>
  <div>
    <!-- Pay -->
    <a-modal v-model="visible" title="Issue details" onOk="handleOk"
      :width="this.settings['isMobileView'] ? 360 : this.settings['isTabletView'] ? 560 : 1080">
      <template slot="footer">
        <a-button key="back" @click="handleCancel">Cancel</a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleEdit">Update/Return</a-button>
      </template>
      <a-spin :spinning="spinning">
        <div v-if="issuedBook && issuedBook.length > 0">
          <div class="row align-items-center">
            <div class="col-md-12">
              <h5 class="font-weight-bold mb-0"> {{ issuedBook[0].student.first_name }}
                {{ issuedBook[0].student.last_name }}
              </h5>
              <p>
                <span class="pr-2">Student ID:</span> <span class="font-weight-bold px-2">{{issuedBook[0].student.student_code }}</span>|
                <span class="px-2">Class:</span> <span class="font-weight-bold px-2">{{issuedBook[0].student.enrollment[0].school_classes.name}}</span>|
                <span class="px-2">Section:</span> <span class="font-weight-bold px-2">{{issuedBook[0].student.enrollment[0].section.name}}</span>|
                <span class="px-2">Roll No:</span> <span class="font-weight-bold px-2">{{issuedBook[0].student.enrollment[0].roll_no}}</span>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <p><span class="pr-2">Issue no.:</span> <span
                  class="font-weight-bold px-2">{{ issuedBook[0].loan_no }}</span></p>
            </div>
            <div class="col-md-4 text-right">
              <p><span class="pr-2">Issue Date:</span> <span
                  class="font-weight-bold px-2">{{ moment(issuedBook[0].loan_date).format('DD-MMM-YYYY h:mm A') }}</span>
              </p>
            </div>
            <div class="col-md-4 text-right">
              <p><span class="pr-2">Expected Return Date:</span> <span
                  class="font-weight-bold px-2">{{ moment(issuedBook[0].expected_return_date).format('DD-MMM-YYYY h:mm') }}
                  </span>
              </p>
            </div>
          </div>
        </div>
        <hr class="m-0">
        Book Details
        <hr class="m-0">
        <!-- starts here -->
        <a-form class="mb-4" :form="form">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Title">
                <a-input placeholder="Title" :disabled="true"
                  v-decorator="['title', { rules: [{ required: false, message: 'Please input book title!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
              </a-form-item>
              <a-form-item label="Author">
                <a-input placeholder="Author" :disabled="true"
                  v-decorator="['author', { rules: [{ required: false, message: 'Please input book author!' }, { max: 300, message: 'Must not exceed 300 characters!' }] }]" />
              </a-form-item>

            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-6">
                  <a-form-item label="Book Code">
                    <a-input placeholder="Book code. eg: CHEM-IX-I" :disabled="true"
                      v-decorator="['code', { rules: [{ required: false, message: 'Please input book code!' }, { max: 30, message: 'Must not exceed 30 characters!' }] }]" />
                  </a-form-item>
                </div>
                <div class="col-md-6">
                  <a-form-item label="Rack Name/Number">
                    <a-input placeholder="Rack Name/Number" :disabled="true"
                      v-decorator="['rack_name', { rules: [{ required: false, message: 'Please input rack name!' }] }]" />
                  </a-form-item>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <a-form-item label="Category">
                    <a-select placeholder="Select category" :disabled="true"
                      v-decorator="['category_id', { rules: [{ required: false, message: 'Please select a category!' }] }]">
                      <a-select-option v-for="(cat, index) in categories" :key="index"
                        :value="cat.id">{{ cat.name }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </div>
                <div class="col-md-6">
                  <a-form-item label="Class">
                    <a-select v-decorator="['class_id', { rules: [{ required: false, message: 'Please select a class!!' }] }]"
                      placeholder="Select class" :disabled="true">
                      <a-select-option v-for="(sclass, index) in schoolClasses" :value="sclass.id" :key="index">
                        {{ sclass.name }}
                      </a-select-option>

                    </a-select>
                  </a-form-item>
                </div>
              </div>

              <!-- <div class="row">
              <div class="col-md-6">
                <a-form-item label="No. of Copies">
                  <a-input-number
                    style="width: 100%"
                    placeholder="No. of Copies"
                    v-decorator="['total_quantity', {rules: [{ required: false, message: 'Please input book quantity!' }]}]"
                  />
                </a-form-item>
              </div>

              <div class="col-md-6">
                <a-form-item label="Class">
                  <a-select
                    v-decorator="['class_id',{rules: [{ required: false, message: 'Please select a class!!' }]}]"
                    placeholder="Select class">
                    >
                    <a-select-option v-for="(sclass, index) in schoolClasses" :value="sclass.id" :key="index">
                        {{sclass.name}}
                      </a-select-option>
                  </a-select>
                </a-form-item>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <a-form-item label="Issue Copies">
                  <a-input-number
                    style="width: 100%"
                    placeholder="Issued Copies"
                    v-decorator="['issued_quantity', {rules: [{ required: false, message: 'Please input book quantity!' }]}]"
                  />
                </a-form-item>
              </div>

              <div class="col-md-6">
                <a-form-item label="Available Copies">
                  <a-input-number
                    style="width: 100%"
                    placeholder="Available Copies"
                    v-decorator="['available_quantity', {rules: [{ required: false, message: 'Please input book quantity!' }]}]"
                  />
                </a-form-item>
              </div>
            </div> -->
            </div>

          </div>

          <hr class="m-0">
          Return Book
          <hr class="m-0">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Remark">
                <a-textarea placeholder="Remark" :autosize="{ minRows: 2 }"
                  v-decorator="['remark', { rules: [{ max: 100, message: 'Must not exceed 100 characters!' }] }]" />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Status" class="col-md-6">
                <a-select @change="ifIssued"
                  v-decorator="['status', { rules: [{ required: true, message: 'Please select a status' }], initialValue: 'Issued' },]">
                  <a-select-option v-for="status in loanStatus" :value="status.value" :key="status.value">
                    <span class="text-bold" :style="`font-family:${status.value}`">
                      {{ status.name }}
                    </span>
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="Return Date" class="col-md-6">
                <a-date-picker :disabled="loanState" style="width: 100%"
                  v-decorator="['return_date', { rules: [{ required: !loanState, message: 'Please input date' }], initialValue: moment()},]"
                  :format=dateFormat />
              </a-form-item>
            </div>
          </div>

        </a-form>
        <!-- ends here -->

        <div>
          <p style="margin-bottom: 2px; width: 100%">
            <!-- <span class="pr-2"><b>Paid by: </b>{{issuedBook.paid_by}}</span> -->
            <!-- <span class="pr-2 float-right"><b>Created by: </b> {{issuedBook.created_by.first_name}} {{issuedBook.created_by.last_name}}</span> -->
          </p>
          <!-- <p style="margin-bottom: 2px;"><span class="pr-2"><b>Remark: </b>{{issuedBook.remark}}</span></p> -->
        </div>
      </a-spin>
      <!--      <a-spin :spinning="spinning">
          <div v-if="student && studentFeeData">
            <pay-history :studentFeeData="studentFeeData" :student="student" :schoolData="schoolData" id="feePaymentMistory"/>
          </div>
        </a-spin>-->
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
// import { downloadBill } from '../../common'

const loanStatus = [
  { value: 'Issued', name: 'Issued' },
  { value: 'Returned', name: 'Returned' },
  { value: 'Not Returned', name: 'Not Returned' },
]
export default {
  name: 'IssueDetails',
  components: {
  },
  props: {
    isPublic: {
      default: false,
    },
    schoolData: {
      default: null,
    },
  },
  data: function () {
    return {
      form: this.$form.createForm(this),
      loading: false,
      visible: false,
      spinning: false,
      dateFormat: 'DD-MM-YYYY HH:mm:ss',
      loanStatus,
      loanState: false,
      oldrecord: {},
      issuedBook: [],
      allCategories: [], // All categories including sub categories
      categories: [], // Only the main categories i.e. without subcategories
      subCategories: [],
      schoolClasses: [],
    }
  },
  mounted: function () {
    this.getParentCategories()
    this.$eventBus.$on('openViewOrderDetailsModal', this.showModal)
  },
  computed: {
    ...mapState(['settings', 'user']),
    // ifIssued() {
    //   return this.loanState === 'Issued';
    // },
  },
  methods: {
    moment,
    showModal: function (issuedBook) {
      console.log('inside openViewOrderDetailsModal')
      console.log('issuedBook:: ', issuedBook)
      this.visible = true
      this.spinning = true
      this.oldrecord = issuedBook
      this.loanState = issuedBook['status'] === 'Issued'
      this.getClasses()
      this.getOrderDetails(issuedBook)
    },
    getOrderDetails: function (issuedBook) {
      this.$http
        .get('/api/library/book/loans/' + issuedBook.id)
        .then(({ data }) => {
          this.spinning = false
          this.issuedBook = data.data
          // console.log('issuedBook inside:: ', issuedBook)
          setTimeout(() => {
            this.form.setFieldsValue({
              title: issuedBook['book'].title,
              author: issuedBook['book'].author,
              // description: issuedBook['book'].description,
              category_id: issuedBook['book'].category_id,
              // sub_category_id: issuedBook['book'].sub_category_id,
              class_id: issuedBook['book'].class_id,
              rack_name: issuedBook['book'].rack_name,
              remark: issuedBook['remark'],
              status: issuedBook['status'],
              return_date: issuedBook['return_date'] ? moment(issuedBook['return_date']) : null,
              code: issuedBook['book'].code,
              // total_quantity: issuedBook['book'].total_quantity,
              // available_quantity: issuedBook['book'].balance_quantity,
              // issued_quantity: issuedBook['book'].issued_quantity,
            })
          }, 50)
        })
        .catch(error => {
          this.$nprogress.done()
          this.$neoNotify.error(error)
        })
    },
    getParentCategories: function () {
      this.$http.get('/api/library/category')
        .then(({ data }) => {
          this.allCategories = data.data
          this.categories = this.allCategories.filter((category) => category.parent_id === null)
        })
        .catch(error => {
          console.log(error)
        })
    },
    getSubCategories: function (selectedCategoryId) {
      this.subCategories = this.allCategories.filter((category) => category.parent_id === selectedCategoryId)
    },
    handleCategorySelect: function (selectedCategoryId) {
      console.log('selectedCategoryId:: ', selectedCategoryId)
      this.form.setFieldsValue({
        'sub_category_id': undefined,
      })
      this.getSubCategories(selectedCategoryId)
    },
    ifIssued: function (selectedValue) {
      if (selectedValue === 'Issued') {
        this.loanState = true
        this.form.setFieldsValue({
          return_date: null,
        })
      } else {
        this.loanState = false
      }
    },
    getClasses: function () {
      this.$http.get('/api/class')
        .then(({ data }) => {
          this.schoolClasses = data.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    handleTableUpdate: function () {
      this.$emit('updateTable')
    },
    handleEdit() {
      this.loading = true
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log('old data', this.oldrecord)
          console.log('formdata', values)
          this.$http
            .patch(`/api/library/book/loans/${this.oldrecord.id}`, {
              return_date: values.return_date ? values.return_date.format('YYYY-MM-DD HH:mm:ss') : null,
              status: values.status,
              remark: values.remark,
            })
            .then((resp) => {
              if (resp.status === 200) {
                this.loading = false
                this.visible = false
                this.$emit('onEdited')
                this.$notification['success']({
                  message: 'Successfully returned/updated',
                  description: 'Book returned/updated successfully!',
                })
              } else {
                this.$notification['warning']({
                  message: 'Unknown Error',
                  description: 'There appears to be an error while submitting data.',
                })
              }
              this.form.resetFields()
            })
            .catch(error => {
              this.$neoNotify.error(error)
            })
        }
      })
      this.loading = false
    },
    handleCancel(e) {
      this.visible = false
      this.form.resetFields()
    },
    // downloadBill() {
    //   downloadBill(
    //     this.$http,
    //     this.productOrder.id,
    //     this.productOrder.student.student_code,
    //     this.productOrder.order_no
    //   )
    // },
    print() {
      // Pass the element id here
      this.$htmlToPaper('feePaymentMistory')
    },
  },
}
</script>
